export { GetCategoryNamePipe } from './get-category-name.pipe';
